import React from 'react';
import { View, StyleSheet } from 'react-native';
import type { NavigationProp, ParamListBase, RouteProp } from '@react-navigation/native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { isPhone } from '@helpers';
import { width, scale, role } from '@components/frame';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { SETTINGS_LIMITED_ROUTE } from '@config/tenantRestrictions';

import SettingsNavigationSidebar from '@components/settings/v2/common/navigation';

import SettingsLimitedNavigation from './navigation';
import { useManageSettingsLimited } from './hooks/useManageSettingsLimited';

interface SettingsLimitedProps extends WithColor {
  navigation: NavigationProp<ParamListBase>;
  route: RouteProp<ParamListBase, string>;
}

const SettingsLimited = (props: SettingsLimitedProps) => {
  const { C, navigation, route } = props;
  const { selectedTab, limitedTabs, toggleChangeLanguage, toggleChangeTheme } = useManageSettingsLimited({ route });

  const childProps = {
    ...props,
    selectedTab,
    toggleChangeLanguage,
    toggleChangeTheme,
    role,
    rootStack: SETTINGS_LIMITED_ROUTE,
  };

  if (isPhone) {
    return (
      <View
        testID={TEST_IDS.tenantStatus.settingsLimited.container}
        style={{ flex: 1, backgroundColor: C('Background/Light/Detail') }}
      >
        <SettingsLimitedNavigation {...childProps} />
      </View>
    );
  }

  return (
    <View
      testID={TEST_IDS.tenantStatus.settingsLimited.container}
      style={{ width: '100%', height: '100%', alignItems: 'center', backgroundColor: C('Background/Light/Detail') }}
    >
      <View style={{ width, height: '100%', flexDirection: 'row' }}>
        <View
          style={{
            width: scale(284),
            borderRightColor: C('Hairline/Light/No trans'),
            borderRightWidth: StyleSheet.hairlineWidth,
          }}
        >
          <SettingsNavigationSidebar
            {...{ C, tabs: limitedTabs, selectedTab, navigation, role, rootStack: SETTINGS_LIMITED_ROUTE }}
          />
        </View>
        <View style={{ flex: 1 }}>
          <SettingsLimitedNavigation {...childProps} />
        </View>
      </View>
    </View>
  );
};

export default ColorWrapper(SettingsLimited);
